import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-[#000a11] text-white py-8" data-id="element-58">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-59">
        <div className="text-center text-sm mb-4" data-id="element-60">
          © 2025 Zenora. All Rights Reserved.
          <a href="https://zenora.shop/policies/privacy-policy" className="underline ml-2 mr-1" data-id="element-61">
            Privacy Policy
          </a>
          <a href="https://zenora.shop/policies/terms-of-service" className="underline ml-1" data-id="element-62">
            Terms of Service
          </a>
        </div>
        <div className="text-center text-[14px] max-w-3xl mx-auto text-gray-300" data-id="element-63">
          THIS IS AN ADVERTISEMENT AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
          CONSUMER PROTECTION UPDATE
        </div>
      </div>
    </footer>;
};